import { renderGetHelp, renderLogout, renderSupport } from '../MenuItems';
import {
    hasDispatchTools,
    hasFlitelinkEssential,
    hasFlitelinkPreferred,
    hasFratLicense,
    hasJeppesenDispatch,
    hasSmsLicense,
    hasSupport,
    isCorporate,
    isEmployee,
    isGroupOwner,
    isLoggedInFromCenter,
    isManagingAccount,
    isOrgOwner,
} from 'ff/common/system';
import RenderDefaultMenu from '../Menus/DefaultMenu';
import RenderFspMenu from '../Menus/FSPMenu';
import RenderOrgAdminMenu from 'ff/common/components/FFMenuV2/Menus/OrgAdminMenu';
import fillSpace from 'ff/common/components/FFMenuV2/MenuItems/FillSpace';
import RenderFliteMenu from 'ff/common/components/FFMenuV2/Menus/FliteMenu';
import { RenderMenuParams } from 'ff/common/components/FFMenuV2/RenderMenuParams';
import RenderJraMenu from 'ff/common/components/FFMenuV2/Menus/JraMenu';
import RenderNoSubscriptionMenu from 'ff/common/components/FFMenuV2/Menus/NoSubscriptionMenu';

export function appendMenuItems(
    params: RenderMenuParams,
    shadowRoot: ShadowRoot
) {
    const root = document.createElement('div');
    root.setAttribute('id', 'ffmenu-scrolling-wrapper');
    let menuItems: Array<
        (params: RenderMenuParams) => HTMLElement | HTMLElement[]
    > = [];

    if (
        !params.isActive &&
        !isCorporate(params.currentUser) &&
        params.featureFlags?.['no_sub_view']
    ) {
        menuItems = RenderNoSubscriptionMenu();
    } else if (
        params?.currentUser?.jeppesen_runway_analysis &&
        // Pure Runway Analysis users get the minimal JRA menu. Users who also
        // have Dispatch or SMS/Safety access fall through to the full default
        // menu so they can reach their other entitled features (e.g. Safety).
        !hasDispatchTools(params.currentUser) &&
        !hasSmsLicense(params.currentUser) &&
        !(
            hasFratLicense(params.currentUser) &&
            params.currentUser?.isSafetyManager
        )
    ) {
        menuItems = RenderJraMenu();
    } else if (
        (hasFlitelinkPreferred(params.currentUser) ||
            hasFlitelinkEssential(params.currentUser)) &&
        !hasDispatchTools(params.currentUser)
    ) {
        menuItems = RenderFliteMenu(params);
    } else if (!isLoggedInFromCenter() && isManagingAccount(params.currentUser))
        menuItems = RenderFspMenu(params);
    else if (
        (isOrgOwner(params.currentUser) || isGroupOwner(params.currentUser)) &&
        isCorporate(params.currentUser) &&
        //We check if isEmployee because the above two checks will include all FF staff accounts. All FF Staff have
        // accounts that have 10 licenses, and that qualifies as "isCorporate", and all individual accounts are
        // 'org-owner. To avoid confusion, filter out FF accounts
        !isEmployee(params.currentUser)
    ) {
        menuItems = RenderOrgAdminMenu(params);
    } else {
        menuItems = RenderDefaultMenu(params);
    }

    //define currentUser in case it is not defined (when user not logged in). Menu items then don't need to worry
    // about the undefined currentUser case
    params = { ...params, currentUser: params.currentUser || {} };

    menuItems
        .filter(Boolean)
        .map(fn => fn(params))
        .flat()
        .filter(d => d)
        .forEach(root.appendChild.bind(root));

    // Learn & Solve/Support link should show for all users except Jeppesen Dispatch (lowCA)
    if (!hasJeppesenDispatch(params?.currentUser)) {
        root.appendChild(renderSupport());
    }
    // Still Need Help link should show for business accounts (multi license) or users with premium / pro support
    if (hasSupport() || isCorporate()) {
        root.appendChild(renderGetHelp(params));
    }
    root.appendChild(renderLogout(params));

    root.appendChild(fillSpace({ 'margin-bottom': '14px' }));

    shadowRoot.appendChild(root);
}
